var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalBar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.80078V28.8008C3 28.9112 3.08954 29.0008 3.2 29.0008H29.2",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7667 10.7L18.44 10.7C18.4731 10.7 18.5 10.6731 18.5 10.64L18.5 9.1L18.5 7.56C18.5 7.52686 18.4731 7.5 18.44 7.5L14.7667 7.5L11.0333 7.5L7.36 7.5C7.32686 7.5 7.3 7.52686 7.3 7.56L7.3 9.1L7.3 10.64C7.3 10.6731 7.32686 10.7 7.36 10.7L11.0333 10.7L14.7667 10.7Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2333 17.8992L14.64 17.8992C14.6731 17.8992 14.7 17.8724 14.7 17.8392L14.7 16.2992L14.7 14.7592C14.7 14.7261 14.6731 14.6992 14.64 14.6992L12.2333 14.6992L9.76662 14.6992L7.35995 14.6992C7.32681 14.6992 7.29995 14.7261 7.29995 14.7592L7.29995 16.2992L7.29995 17.8392C7.29995 17.8724 7.32681 17.8992 7.35995 17.8992L9.76662 17.8992L12.2333 17.8992Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9001 25.1004L24.6401 25.1004C24.6732 25.1004 24.7001 25.0735 24.7001 25.0404L24.7001 23.5004L24.7001 21.9604C24.7001 21.9273 24.6732 21.9004 24.6401 21.9004L18.9001 21.9004L13.1001 21.9004L7.36007 21.9004C7.32693 21.9004 7.30007 21.9273 7.30007 21.9604L7.30007 23.5004L7.30007 25.0404C7.30007 25.0735 7.32693 25.1004 7.36007 25.1004L13.1001 25.1004L18.9001 25.1004Z",
    stroke: "#CE375C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBar2);
export default __webpack_public_path__ + "static/media/horizontal-bar-2.db7f6873622c4c6bcc82469585585754.svg";
export { ForwardRef as ReactComponent };